/*
 * @Author: zhang lin
 * @Date: 2022-05-27 14:31:04
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-06-24 09:18:55
 * @Description: file content
 */
import React from 'react';
import styles from './FailureList.less';
import { formatDate } from 'root/utils/utils';

interface propsType {
  data: any[];
}

const FailureList = (props: propsType) => {
  const { data } = props;
  return (
    <ul className={styles.failureList}>
      {data.map((item) => {
        return (
          <li key={item.startTime} className={!item.success ? styles.failureItem : null}>
            <span className={styles.date}>
              {item.finishTime ? formatDate(item.finishTime) : formatDate(item.startTime)}
            </span>
            <span className={styles.text}>{item.detail}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default FailureList;
